import React from 'react';

import ContentViewShopComponent from '#app/Component/ContentViewShopComponent';
import List from '#app/View/Shop/Sale/SelectClient/components/List';
import Search from '#app/View/Shop/Sale/SelectClient/components/Search';
import useClientList from '#app/View/Shop/Sale/SelectClient/hooks/useClientList';
import ShopCreateClientForm from '#app/View/Shop/Sale/components/ShopCreateClientForm';

const SaleOrderClientList: React.FC = () => {
  const { setFilters, ...props } = useClientList();

  return (
    <ContentViewShopComponent>
      <ShopCreateClientForm />
      <Search handleSearch={(data) => setFilters(data)} />
      <List {...props} />
    </ContentViewShopComponent>
  );
};

export default SaleOrderClientList;
